module.exports = __webpack_public_path__ + "static/img/14.b297ae5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/14.png
// module id = WQYR
// module chunks = 0